import React from "react"
import { modelReportShow, panelsReport, isSelected } from "../config/Helpers";
import DayPicker, { DateUtils } from "react-day-picker";
import moment from "moment";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import MomentLocaleUtils,{ formatDate, parseDate, current_year, past_year, months } from "react-day-picker/moment";

class ReportModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows_models: "",
            rows_reports: "",
            interval_days_analysis : {
                status : "hide-panel",
                key : "1 DÍA",
                value : 1
            },
            interval_days_send : {
                status : "hide-panel",
                key : "1 DÍA",
                value : 1
            },
            panels_report : {
                status : "hide-panel",
                key : "TODOS",
                value : 1    
            },
            datepicker                : { from : undefined,  to : undefined },
            month_select              : new Date(2018,0),
            from_month_current        : new Date(2018,0),
            to_month_current          : new Date(2018,11),
            tags: [],
            saveBtnState : "",
            shareBtnState : "",
            moreBtnState : "hide",
            step_active : "1",
            type_select : "",
            notify_email: false,
            private_url: false,
            dinamyc_report: false
        }
        this.handleChange       = this.handleChange.bind(this);      
        this.handleDayClick     = this.handleDayClick.bind(this);
        this.setDefaultValues   = this.setDefaultValues.bind(this);
    }
    handleChange(tags) {
        this.setState({tags})
    }
    handleDayClick(day) {
        let day_last_year = new Date(day);
        let year          = day_last_year.getFullYear();
        this.setState({ 
            month_select        :  new Date(year, day_last_year.getMonth()),
        })
        
        let range = DateUtils.addDayToRange(day, this.state.datepicker);
        range     = DateUtils.addDayToRange(day, range);

        this.setState({ datepicker : range });
    }
    handleClick(type) {
        this.setDefaultValues()
        this.props.reportModelState(type)
    }
    handleClickMenu(select) {
        //this.props.hideSelects();
        this.setState((prev)=> {
            const status = prev[select]["status"] === "hide-panel" ? "" : "hide-panel";
            return {
                [select] : {
                    status : status,
                    key : prev[select].key
                }
            }
        })
    }
    setDefaultValues(){
        this.setState({
            rows_models: "",
            rows_reports: "",
            interval_days_analysis : {
                status : "hide-panel",
                key : "1 DÍA",
                value : 1
            },
            interval_days_send : {
                status : "hide-panel",
                key : "1 DÍA",
                value : 1
            },
            panels_report : {
                status : "hide-panel",
                key : "TODOS",
                value : 1    
            },
            datepicker                : { from : undefined,  to : undefined },
            month_select              : new Date(2018,0),
            from_month_current        : new Date(2018,0),
            to_month_current          : new Date(2018,11),
            tags: [],
            saveBtnState : "",
            shareBtnState : "",
            moreBtnState : "hide",
            step_active : "1",
            type_select : "",
            notify_email : false,
            private_url : false,
            dinamyc_report : false
        })
    }
    handleClickMenuItem(keyText, valueText, menu) {
        let $self = this;
        switch (menu) {
            case "period_menu":
                this.setState({ 
                    current_period : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.setRangeCustom(valueText))
            break;
            case "views_menu":
                this.setState({ 
                    current_view_review : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;
            case "reservation_chart_menu":
                this.setState({ 
                    current_view_reservation : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;

            case "leadtime_chart_menu":
                this.setState({ 
                    current_view_leadtime : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;
            case "status_menu":
                this.setState({
                    current_status : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.props.setTypeDateQuery(valueText))
            break;
            case "comp_menu":
                this.setState({
                    current_comp : { 
                        key : keyText, value : valueText 
                    } 
                })
            break;
            case "comp_year":
                this.changeDatesByYear('current', valueText)
            break;
            case "comp_past_year":
                this.changeDatesByYear('compare', valueText)
            break;
            case "custom_compare":
                this.setState({
                    current_option_compare : { key : keyText, value : valueText } 
                }, () => {
                    if(valueText === "custom_past_year"){
                        this.setState({ datepicker_compare : '' })
                    }else{
                        this.setState({ datepicker_compare : 'hide' })
                    }
                })
            break;
            case "days":
                var array_elements  = this.state.active_days

                if(array_elements[valueText] === undefined){
                    array_elements[valueText] = { day : keyText, value : valueText }
                }else{
                    delete array_elements[valueText];
                }
                this.setState({
                    active_days : array_elements,
                })
            break;
        }
    }
    activeReport(type){
        this.setState((prev) => {
            if(prev.type_select !== type){
              return { type_select : type}
            }
        })
    }

    setNotifyByEmail(notify){
        this.setState((prev) => {
            if (prev.notify_email !== notify) {
                return { notify_email: notify }
            }
        })
    }
    setPrivateUrl(notify) {
        this.setState((prev) => {
            if (prev.private_url !== notify) {
                return { private_url: notify }
            }
        })
    }
    setDinamycReport(notify) {
        this.setState((prev) => {
            if (prev.dinamyc_report !== notify) {
                return { dinamyc_report: notify }
            }
        })
    }
    actionReport(action){
        if(action === "save"){
            this.setDefaultValues()
            this.props.reportModelState('reports-new')
        } else if (action === "share") {
            this.setState({
                step_active : "2",
                shareBtnState : "hide",
                saveBtnState : "btn-full"
            })
        } else if (action === "more") {
            this.setState({
                step_active: "3"
            })
        }
    }
    componentWillReceiveProps() {
        let rows_models = [], rows_reports = [];
        for (let index = 0; index < 10; index++) {
            rows_models[index] = (
                <div className={"row-list " + (index % 2 ? "row-c" : "")}>
                    <div>lorem impusns sadas </div>
                    <div>
                        <a className="apply">Aplicar</a>
                        <a className="share">Compartir</a>
                        <a className="remove">Eliminar</a>
                    </div>
                </div>
            );
            rows_reports[index] = (
                <div className={"row-list " + (index % 2 ? "row-c" : "")}>
                    <div>lorem impusns sadass</div>
                    <div>
                        <a className="apply">Aplicar</a>
                        <a className="share">Compartir</a>
                        <a className="remove">Eliminar</a>
                    </div>
                </div>
            );
        }

        this.setState({
            rows_models: rows_models,
            rows_reports: rows_reports
        })
    }

    componentWillMount(){
        let day     = new Date();
        let year    = day.getFullYear();
        let range   = DateUtils.addDayToRange(day, this.state.datepicker);
        range       = DateUtils.addDayToRange(day, range);

        this.setState({ 
            month_select        : new Date(year, day.getMonth()),
            from_month_current  : new Date(year, day.getMonth()),
            datepicker          : range
        })
    }
    render() {
        const listReports = panelsReport.map((item, index) =>
            <li key={"days-analysis-" + index} className={isSelected(item.value, this.state.panels_report.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "panels_report")}>
                {item.key}
            </li>
        );

        const { from, to }  = this.state.datepicker;
        const modifiers     = { start: from, end: to };
        
        return (
            <div className={"container-alerts " + modelReportShow(this.props)}>
                <div className={"alert-models-modal form-new " + this.props.alert_modal_report_new}>
                    <h3>GUARDAR REPORTE <span className="close-modal" onClick={this.handleClick.bind(this, "reports-new")}>X</span></h3>
                    <div className="container-list">
                        <div className={"step-1 " + (this.state.step_active !== "1" ? "hide" : "")}>
                            <span>Selecciona como deseas guardar tu reporte:</span>
                            <div className="types-report">
                                <a className={this.state.type_select === "fixed" ? "active" : ""} onClick={this.activeReport.bind(this, "fixed")}>REPORTE FIJO</a> 
                                <span className="more-info-report">?</span>
                                <span>ó</span>
                                <a className={this.state.type_select === "dynamic" ? "active" : ""} onClick={this.activeReport.bind(this, "dynamic")}>REPORTE DINÁMICO</a> 
                                <span className="more-info-report">?</span>
                            </div>
                            <div className={"data-report " + (this.state.type_select === "" ? "hide" : "")}>
                                <div>
                                    <h4 className="data-title">
                                        Datos del reporte
                                    </h4>
                                    <input type="text" placeholder="Nombre del reporte" />
                                </div>
                                <div className={"two-colums " + (this.state.type_select !== "dynamic" ? "hide" : "")}>
                                    <div className="">
                                        <span>Intervalo de análisis (días)</span>
                                    </div>
                                    <div className="">
                                        <input type="number" placeholder="Días" className="interval-days" name="interval_analysis" min="1" max="31" />
                                    </div>
                                </div>
                                <div className="notify-email">
                                    <p>¿Deseas recibir este reporte en PDF en tu correo?</p>
                                    <div className="radios-option margin-r" onClick={this.setNotifyByEmail.bind(this, true)}>
                                        <span>Sí</span>
                                        <input type="radio" name="notify-email" checked={this.state.notify_email === true ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                    <div className="radios-option" onClick={this.setNotifyByEmail.bind(this, false)}>
                                        <span>No </span>
                                        <input type="radio" name="notify-email" checked={this.state.notify_email === false ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                </div>
                                <div className={"two-colums " + (this.state.notify_email === false ? "hide" : "")}>
                                    <div className="">
                                        <span>Intervalo de envío (días)</span>
                                    </div>
                                    <div className="">
                                        <input type="number" placeholder="Días" className="interval-days" name="interval_analysis" min="1" max="31" />
                                    </div>
                                </div>
                                <div className={"two-colums " + (this.state.notify_email === false ? "hide" : "")}>
                                    <div className="">
                                        <span>¿Que día deseas iniciar el envío?</span>
                                    </div>
                                    <div className="datepicker-wdg">
                                        <DayPicker 
                                            className="Selectable"
                                            numberOfMonths={1}
                                            month={this.state.month_select}
                                            fromMonth={this.state.from_month_current}
                                            toMonth={this.state.to_month_current}
                                            pagedNavigation fixedWeeks
                                            localeUtils={MomentLocaleUtils} 
                                            locale="es"
                                            selectedDays={[this.state.datepicker.from, { from : this.state.datepicker.from, to : this.state.datepicker.to }]}
                                            modifiers={ { start : this.state.datepicker.from, end : this.state.datepicker.to } }
                                            onDayClick={this.handleDayClick}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"step-2 " + (this.state.step_active !== "2" ? "hide" : "")}>
                            <p>Reporte: <strong>{"Reporte semanal"}</strong></p>
                            <p>Escribe los correos a los que deseas enviar la liga de este reporte.</p>
                            <div className="emails-share">
                                <TagsInput 
                                    value={this.state.tags} 
                                    onChange={this.handleChange} 
                                    inputProps={{
                                        placeholder : 'Agregar email',
                                        className : "inputEmailAdd"
                                    }}/>
                            </div>
                            <p>Incluir mensaje en el reporte</p>
                            <textarea className="message-email" placeholder="Texto personalizado para los usuarios"></textarea>
                            <div className="two-colums">
                                <div className="">
                                    <span>Dashboards en el reporte (días):</span>
                                    <span className="more-info-report">?</span>
                                </div>
                                <div className="">
                                    <div className={"select-style type-two " + this.state.panels_report.status } onClick={this.handleClickMenu.bind(this, "panels_report")}>
                                        <span className="input-filters select blue custom-period">
                                            <span title={this.state.panels_report.key}>{this.state.panels_report.key}</span>
                                            <ul>
                                                {listReports}
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="two-colums">
                                <div className="">
                                    <span>Disponibilidad del reporte (días):</span>
                                    <span className="more-info-report">?</span>
                                </div>
                                <div className="">
                                    <input type="number" placeholder="Días"  className="interval-days" name="interval_analysis" min="1" max="31" />
                                </div>
                            </div>
                            <div className="two-colums">
                                <div className="">
                                    <span>Interacción del reporte:</span>
                                    <span className="more-info-report">?</span>
                                </div>
                                <div className="radio-section">
                                    <div className="radios-option margin-r" onClick={this.setDinamycReport.bind(this, true)}>
                                        <span>Sí</span>
                                        <input type="radio" name="dinamic-report" checked={this.state.dinamyc_report === true ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                    <div className="radios-option left-margin" onClick={this.setDinamycReport.bind(this, false)}>
                                        <span>No </span>
                                        <input type="radio" name="dinamic-report" checked={this.state.dinamyc_report === false ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="two-colums">
                                <div className="radio-section">
                                    <span>¿Deseas URL privada?</span>
                                    <span className="more-info-report">?</span>
                                </div>
                                <div className="">
                                    <div className="radios-option margin-r" onClick={this.setPrivateUrl.bind(this, true)}>
                                        <span>Sí</span>
                                        <input type="radio" name="private-url" checked={this.state.private_url === true ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                    <div className="radios-option" onClick={this.setPrivateUrl.bind(this, false)}>
                                        <span>No </span>
                                        <input type="radio" name="private-url" checked={this.state.private_url === false ? true : false}/>
                                        <span className="checkmark"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"step-3 " + (this.state.step_active !== "3" ? "hide" : "")}>
                            <p>Reporte: <strong>{"Reporte semanal"}</strong></p>
                            <p>Personas con acceso a los reportes o que a los que ha sido compartido.</p>
                            <table>
                                <tr>
                                    <th>Correo electrónico</th>
                                    <th>Fecha de envío</th>
                                    <th>Estatus</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Vigente</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Vigente</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Vigente</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="footer-actions">
                            <a onClick={this.actionReport.bind(this, 'share')} className={this.state.shareBtnState + " "+ (this.state.type_select === "" ? "hide" : "")}>COMPARTIR</a>
                            <a onClick={this.actionReport.bind(this, 'save')} className={this.state.saveBtnState + " " + (this.state.type_select === "" ? "hide" : "")}>GUARDAR</a>
                            <a onClick={this.actionReport.bind(this, 'more')} className={this.state.moreBtnState + " " + (this.state.type_select === "" ? "hide" : "")}>AGREGAR MÁS</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReportModel


// WEBPACK FOOTER //
// ./src/Frontend/reports/ReportModel.js